import HSRater from './HSRater';
export default HSRater